import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { Watchlist } from 'app-components/flux/spending-watchlist';
import { Map as ImmutableMap } from 'immutable';

export const DIALOG_TYPE = 'WATCHLIST_DIALOG';

export const createWatchlistModal = (
  watchlist: Watchlist | null,
  replaceURL: boolean,
  onClose?: (success?: boolean) => void,
) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: DIALOG_TYPE,
      props: ImmutableMap({
        watchlist,
        replaceURL,
        onClose,
      }),
    }),
  );
